export default "__VITE_ASSET__Fd_Klk3J__"